// extracted by mini-css-extract-plugin
export default {"scroll__false":"ScrollToTop_scroll__false__w2Mtn","scroll__true":"ScrollToTop_scroll__true__xJvkq"};